export const TokenType = {
  INVITE: "INVITE",
  RESET_PASSWORD: "RESET_PASSWORD",
} as const;
export type TokenType = (typeof TokenType)[keyof typeof TokenType];

export const House = {
  BERRYSTEAD: "BERRYSTEAD",
  BRAMSTON: "BRAMSTON",
  CROSBY: "CROSBY",
  DRYDEN: "DRYDEN",
  FISHER: "FISHER",
  GRAFTON: "GRAFTON",
  KIRKEBY: "KIRKEBY",
  LAUNDIMER: "LAUNDIMER",
  LAXTON: "LAXTON",
  NEW: "NEW",
  SADLER: "SADLER",
  SANDERSON: "SANDERSON",
  SCHOOL: "SCHOOL",
  SCOTT: "SCOTT",
  SIDNEY: "SIDNEY",
  STANTHONY: "STANTHONY",
  WYATT: "WYATT",
} as const;
export type House = (typeof House)[keyof typeof House];

export const Form = {
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  L6: "L6",
  LEFT: "LEFT",
  U6: "U6",
} as const;
export type Form = (typeof Form)[keyof typeof Form];

export const ActionType = {
  CREATE: "CREATE",
  DELETE: "DELETE",
  GET: "GET",
  UPDATE: "UPDATE",
} as const;
export type ActionType = (typeof ActionType)[keyof typeof ActionType];

export const ActionObject = {
  DIRECTOR: "DIRECTOR",
  EPISODE: "EPISODE",
  PAGE: "PAGE",
  PUPIL: "PUPIL",
  SHOW: "SHOW",
  SUPERVISOR: "SUPERVISOR",
} as const;
export type ActionObject = (typeof ActionObject)[keyof typeof ActionObject];

export const Setting = {
  CURRENT_SEASON: "CURRENT_SEASON",
  DEFAULT_ICON: "DEFAULT_ICON",
  FACEBOOK: "FACEBOOK",
  INSTAGRAM: "INSTAGRAM",
  TWITTER: "TWITTER",
} as const;
export type Setting = (typeof Setting)[keyof typeof Setting];

export interface Supervisor {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  email: string;
  password: string;
}

export interface Director {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  role: string;
  password: string;
  permissions: string[];
}

export interface SupervisorEmailToken {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  supervisorId: string;
  used: boolean;
  type: TokenType;
  email: string;
}

export interface Pupil {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  firstName: string;
  surname: string;
  house: House;
  form: Form;
  classOf: number;
  hostingEpisodeIds: string[];
  directingEpisodeIds: string[];
}

export interface Page {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  name: string;
  category: string | null;
  content: string;
  version: number;
}

export interface Show {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  name: string;
  description: string | null;
  iconStoragePath: string | null;
}

export interface Episode {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deleted: boolean;
  showId: string;
  startOfEpisode: Date;
  endOfEpisode: Date;
  title: string;
  hostIds: string[];
  techieId: string | null;
  directorIds: string[];
  cancelled: boolean;
  special: boolean;
  iconStoragePath: string | null;
}

export interface Recording {
  episodeId: string;
  createdAt: Date;
  updatedAt: Date;
  storagePath: string | null;
}

export interface Action {
  id: string;
  createdAt: Date;
  type: ActionType;
  object: ActionObject;
  objectId: string;
  directorId: string | null;
  supervisorId: string | null;
  reversible: boolean;
  rolledBack: boolean;
}

export interface SiteSetting {
  updatedAt: Date;
  type: Setting;
  value: string;
}

export interface Session {
  user: {
    id?: string;
    type?: "supervisor" | "director";
  };
}
